import ApplicationController from '../application_controller'

class InitPopoverController extends ApplicationController {
  connect () {
    $('[data-bs-toggle="popover"]').popover({ trigger: 'focus' })
  }
}

export default InitPopoverController
